/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PlayerRouteImport } from './routes/_player'
import { Route as AuthForgotRouteImport } from './routes/_auth.forgot'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthRegisterRouteImport } from './routes/_auth.register'
import { Route as PlayerIndexRouteImport } from './routes/_player.index'
import { Route as PlayerHistoryRouteImport } from './routes/_player.history'
import { Route as PlayerKycRouteImport } from './routes/_player.kyc'
import { Route as PlayerProfileRouteImport } from './routes/_player.profile'
import { Route as PlayerRedeemRouteImport } from './routes/_player.redeem'
import { Route as PlayerReferralRouteImport } from './routes/_player.referral'
import { Route as PlayerSettingsRouteImport } from './routes/_player.settings'
import { Route as PlayerSpinRouteImport } from './routes/_player.spin'
import { Route as PlayerSportsRouteImport } from './routes/_player.sports'
import { Route as PlayerSupportRouteImport } from './routes/_player.support'
import { Route as PlayerWalletRouteImport } from './routes/_player.wallet'
import { Route as LoginImpersonateRouteImport } from './routes/login.impersonate'
import { Route as PlayerCasinoIndexRouteImport } from './routes/_player.casino.index'
import { Route as PlayerCasinoCodeRouteImport } from './routes/_player.casino.$code'
import { Route as PlayerLotteryIndexRouteImport } from './routes/_player.lottery.index'
import { Route as PlayerLotteryCodeRouteImport } from './routes/_player.lottery.$code'
import { Route as PlayerLotteryResultsRouteImport } from './routes/_player.lottery.results'
import { Route as PlayerLotteryTicketsRouteImport } from './routes/_player.lottery.tickets'
import { Route as PlayerPromosIndexRouteImport } from './routes/_player.promos.index'
import { Route as PlayerPromosHistoryRouteImport } from './routes/_player.promos.history'
import { Route as PlayerWalletIndexRouteImport } from './routes/_player.wallet.index'
import { Route as PlayerWalletDepositRouteImport } from './routes/_player.wallet.deposit'
import { Route as PlayerWalletWithdrawRouteImport } from './routes/_player.wallet.withdraw'
import { Route as PlayerGamesOriginalsIndexRouteImport } from './routes/_player.games.originals.index'
import { Route as PlayerGamesOriginalsCodeRouteImport } from './routes/_player.games.originals.$code'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayerRoute = PlayerRouteImport.update({
  id: '/_player',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const PlayerIndexRoute = PlayerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerHistoryRoute = PlayerHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerKycRoute = PlayerKycRouteImport.update({
  id: '/kyc',
  path: '/kyc',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerProfileRoute = PlayerProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerRedeemRoute = PlayerRedeemRouteImport.update({
  id: '/redeem',
  path: '/redeem',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerReferralRoute = PlayerReferralRouteImport.update({
  id: '/referral',
  path: '/referral',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerSettingsRoute = PlayerSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerSpinRoute = PlayerSpinRouteImport.update({
  id: '/spin',
  path: '/spin',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerSportsRoute = PlayerSportsRouteImport.update({
  id: '/sports',
  path: '/sports',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerSupportRoute = PlayerSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerWalletRoute = PlayerWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => PlayerRoute,
} as any)
const LoginImpersonateRoute = LoginImpersonateRouteImport.update({
  id: '/login/impersonate',
  path: '/login/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayerCasinoIndexRoute = PlayerCasinoIndexRouteImport.update({
  id: '/casino/',
  path: '/casino/',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerCasinoCodeRoute = PlayerCasinoCodeRouteImport.update({
  id: '/casino/$code',
  path: '/casino/$code',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerLotteryIndexRoute = PlayerLotteryIndexRouteImport.update({
  id: '/lottery/',
  path: '/lottery/',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerLotteryCodeRoute = PlayerLotteryCodeRouteImport.update({
  id: '/lottery/$code',
  path: '/lottery/$code',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerLotteryResultsRoute = PlayerLotteryResultsRouteImport.update({
  id: '/lottery/results',
  path: '/lottery/results',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerLotteryTicketsRoute = PlayerLotteryTicketsRouteImport.update({
  id: '/lottery/tickets',
  path: '/lottery/tickets',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerPromosIndexRoute = PlayerPromosIndexRouteImport.update({
  id: '/promos/',
  path: '/promos/',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerPromosHistoryRoute = PlayerPromosHistoryRouteImport.update({
  id: '/promos/history',
  path: '/promos/history',
  getParentRoute: () => PlayerRoute,
} as any)
const PlayerWalletIndexRoute = PlayerWalletIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlayerWalletRoute,
} as any)
const PlayerWalletDepositRoute = PlayerWalletDepositRouteImport.update({
  id: '/deposit',
  path: '/deposit',
  getParentRoute: () => PlayerWalletRoute,
} as any)
const PlayerWalletWithdrawRoute = PlayerWalletWithdrawRouteImport.update({
  id: '/withdraw',
  path: '/withdraw',
  getParentRoute: () => PlayerWalletRoute,
} as any)
const PlayerGamesOriginalsIndexRoute =
  PlayerGamesOriginalsIndexRouteImport.update({
    id: '/games/originals/',
    path: '/games/originals/',
    getParentRoute: () => PlayerRoute,
  } as any)
const PlayerGamesOriginalsCodeRoute =
  PlayerGamesOriginalsCodeRouteImport.update({
    id: '/games/originals/$code',
    path: '/games/originals/$code',
    getParentRoute: () => PlayerRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PlayerIndexRoute
  '/forgot': typeof AuthForgotRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/history': typeof PlayerHistoryRoute
  '/kyc': typeof PlayerKycRoute
  '/profile': typeof PlayerProfileRoute
  '/redeem': typeof PlayerRedeemRoute
  '/referral': typeof PlayerReferralRoute
  '/settings': typeof PlayerSettingsRoute
  '/spin': typeof PlayerSpinRoute
  '/sports': typeof PlayerSportsRoute
  '/support': typeof PlayerSupportRoute
  '/wallet': typeof PlayerWalletRouteWithChildren
  '/login/impersonate': typeof LoginImpersonateRoute
  '/casino/$code': typeof PlayerCasinoCodeRoute
  '/lottery/$code': typeof PlayerLotteryCodeRoute
  '/lottery/results': typeof PlayerLotteryResultsRoute
  '/lottery/tickets': typeof PlayerLotteryTicketsRoute
  '/promos/history': typeof PlayerPromosHistoryRoute
  '/wallet/deposit': typeof PlayerWalletDepositRoute
  '/wallet/withdraw': typeof PlayerWalletWithdrawRoute
  '/casino/': typeof PlayerCasinoIndexRoute
  '/lottery/': typeof PlayerLotteryIndexRoute
  '/promos/': typeof PlayerPromosIndexRoute
  '/wallet/': typeof PlayerWalletIndexRoute
  '/games/originals/$code': typeof PlayerGamesOriginalsCodeRoute
  '/games/originals/': typeof PlayerGamesOriginalsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof PlayerIndexRoute
  '/forgot': typeof AuthForgotRoute
  '/login': typeof AuthLoginRoute
  '/register': typeof AuthRegisterRoute
  '/history': typeof PlayerHistoryRoute
  '/kyc': typeof PlayerKycRoute
  '/profile': typeof PlayerProfileRoute
  '/redeem': typeof PlayerRedeemRoute
  '/referral': typeof PlayerReferralRoute
  '/settings': typeof PlayerSettingsRoute
  '/spin': typeof PlayerSpinRoute
  '/sports': typeof PlayerSportsRoute
  '/support': typeof PlayerSupportRoute
  '/login/impersonate': typeof LoginImpersonateRoute
  '/casino/$code': typeof PlayerCasinoCodeRoute
  '/lottery/$code': typeof PlayerLotteryCodeRoute
  '/lottery/results': typeof PlayerLotteryResultsRoute
  '/lottery/tickets': typeof PlayerLotteryTicketsRoute
  '/promos/history': typeof PlayerPromosHistoryRoute
  '/wallet/deposit': typeof PlayerWalletDepositRoute
  '/wallet/withdraw': typeof PlayerWalletWithdrawRoute
  '/casino': typeof PlayerCasinoIndexRoute
  '/lottery': typeof PlayerLotteryIndexRoute
  '/promos': typeof PlayerPromosIndexRoute
  '/wallet': typeof PlayerWalletIndexRoute
  '/games/originals/$code': typeof PlayerGamesOriginalsCodeRoute
  '/games/originals': typeof PlayerGamesOriginalsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_player': typeof PlayerRouteWithChildren
  '/_auth/forgot': typeof AuthForgotRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_player/history': typeof PlayerHistoryRoute
  '/_player/kyc': typeof PlayerKycRoute
  '/_player/profile': typeof PlayerProfileRoute
  '/_player/redeem': typeof PlayerRedeemRoute
  '/_player/referral': typeof PlayerReferralRoute
  '/_player/settings': typeof PlayerSettingsRoute
  '/_player/spin': typeof PlayerSpinRoute
  '/_player/sports': typeof PlayerSportsRoute
  '/_player/support': typeof PlayerSupportRoute
  '/_player/wallet': typeof PlayerWalletRouteWithChildren
  '/login/impersonate': typeof LoginImpersonateRoute
  '/_player/': typeof PlayerIndexRoute
  '/_player/casino/$code': typeof PlayerCasinoCodeRoute
  '/_player/lottery/$code': typeof PlayerLotteryCodeRoute
  '/_player/lottery/results': typeof PlayerLotteryResultsRoute
  '/_player/lottery/tickets': typeof PlayerLotteryTicketsRoute
  '/_player/promos/history': typeof PlayerPromosHistoryRoute
  '/_player/wallet/deposit': typeof PlayerWalletDepositRoute
  '/_player/wallet/withdraw': typeof PlayerWalletWithdrawRoute
  '/_player/casino/': typeof PlayerCasinoIndexRoute
  '/_player/lottery/': typeof PlayerLotteryIndexRoute
  '/_player/promos/': typeof PlayerPromosIndexRoute
  '/_player/wallet/': typeof PlayerWalletIndexRoute
  '/_player/games/originals/$code': typeof PlayerGamesOriginalsCodeRoute
  '/_player/games/originals/': typeof PlayerGamesOriginalsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot'
    | '/login'
    | '/register'
    | '/history'
    | '/kyc'
    | '/profile'
    | '/redeem'
    | '/referral'
    | '/settings'
    | '/spin'
    | '/sports'
    | '/support'
    | '/wallet'
    | '/login/impersonate'
    | '/casino/$code'
    | '/lottery/$code'
    | '/lottery/results'
    | '/lottery/tickets'
    | '/promos/history'
    | '/wallet/deposit'
    | '/wallet/withdraw'
    | '/casino/'
    | '/lottery/'
    | '/promos/'
    | '/wallet/'
    | '/games/originals/$code'
    | '/games/originals/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot'
    | '/login'
    | '/register'
    | '/history'
    | '/kyc'
    | '/profile'
    | '/redeem'
    | '/referral'
    | '/settings'
    | '/spin'
    | '/sports'
    | '/support'
    | '/login/impersonate'
    | '/casino/$code'
    | '/lottery/$code'
    | '/lottery/results'
    | '/lottery/tickets'
    | '/promos/history'
    | '/wallet/deposit'
    | '/wallet/withdraw'
    | '/casino'
    | '/lottery'
    | '/promos'
    | '/wallet'
    | '/games/originals/$code'
    | '/games/originals'
  id:
    | '__root__'
    | '/_auth'
    | '/_player'
    | '/_auth/forgot'
    | '/_auth/login'
    | '/_auth/register'
    | '/_player/history'
    | '/_player/kyc'
    | '/_player/profile'
    | '/_player/redeem'
    | '/_player/referral'
    | '/_player/settings'
    | '/_player/spin'
    | '/_player/sports'
    | '/_player/support'
    | '/_player/wallet'
    | '/login/impersonate'
    | '/_player/'
    | '/_player/casino/$code'
    | '/_player/lottery/$code'
    | '/_player/lottery/results'
    | '/_player/lottery/tickets'
    | '/_player/promos/history'
    | '/_player/wallet/deposit'
    | '/_player/wallet/withdraw'
    | '/_player/casino/'
    | '/_player/lottery/'
    | '/_player/promos/'
    | '/_player/wallet/'
    | '/_player/games/originals/$code'
    | '/_player/games/originals/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  PlayerRoute: typeof PlayerRouteWithChildren
  LoginImpersonateRoute: typeof LoginImpersonateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_player': {
      id: '/_player'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PlayerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/forgot': {
      id: '/_auth/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_player/': {
      id: '/_player/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PlayerIndexRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/history': {
      id: '/_player/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof PlayerHistoryRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/kyc': {
      id: '/_player/kyc'
      path: '/kyc'
      fullPath: '/kyc'
      preLoaderRoute: typeof PlayerKycRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/profile': {
      id: '/_player/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof PlayerProfileRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/redeem': {
      id: '/_player/redeem'
      path: '/redeem'
      fullPath: '/redeem'
      preLoaderRoute: typeof PlayerRedeemRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/referral': {
      id: '/_player/referral'
      path: '/referral'
      fullPath: '/referral'
      preLoaderRoute: typeof PlayerReferralRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/settings': {
      id: '/_player/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PlayerSettingsRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/spin': {
      id: '/_player/spin'
      path: '/spin'
      fullPath: '/spin'
      preLoaderRoute: typeof PlayerSpinRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/sports': {
      id: '/_player/sports'
      path: '/sports'
      fullPath: '/sports'
      preLoaderRoute: typeof PlayerSportsRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/support': {
      id: '/_player/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof PlayerSupportRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/wallet': {
      id: '/_player/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof PlayerWalletRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/login/impersonate': {
      id: '/login/impersonate'
      path: '/login/impersonate'
      fullPath: '/login/impersonate'
      preLoaderRoute: typeof LoginImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_player/casino/': {
      id: '/_player/casino/'
      path: '/casino'
      fullPath: '/casino/'
      preLoaderRoute: typeof PlayerCasinoIndexRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/casino/$code': {
      id: '/_player/casino/$code'
      path: '/casino/$code'
      fullPath: '/casino/$code'
      preLoaderRoute: typeof PlayerCasinoCodeRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/lottery/': {
      id: '/_player/lottery/'
      path: '/lottery'
      fullPath: '/lottery/'
      preLoaderRoute: typeof PlayerLotteryIndexRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/lottery/$code': {
      id: '/_player/lottery/$code'
      path: '/lottery/$code'
      fullPath: '/lottery/$code'
      preLoaderRoute: typeof PlayerLotteryCodeRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/lottery/results': {
      id: '/_player/lottery/results'
      path: '/lottery/results'
      fullPath: '/lottery/results'
      preLoaderRoute: typeof PlayerLotteryResultsRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/lottery/tickets': {
      id: '/_player/lottery/tickets'
      path: '/lottery/tickets'
      fullPath: '/lottery/tickets'
      preLoaderRoute: typeof PlayerLotteryTicketsRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/promos/': {
      id: '/_player/promos/'
      path: '/promos'
      fullPath: '/promos/'
      preLoaderRoute: typeof PlayerPromosIndexRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/promos/history': {
      id: '/_player/promos/history'
      path: '/promos/history'
      fullPath: '/promos/history'
      preLoaderRoute: typeof PlayerPromosHistoryRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/wallet/': {
      id: '/_player/wallet/'
      path: '/'
      fullPath: '/wallet/'
      preLoaderRoute: typeof PlayerWalletIndexRouteImport
      parentRoute: typeof PlayerWalletRoute
    }
    '/_player/wallet/deposit': {
      id: '/_player/wallet/deposit'
      path: '/deposit'
      fullPath: '/wallet/deposit'
      preLoaderRoute: typeof PlayerWalletDepositRouteImport
      parentRoute: typeof PlayerWalletRoute
    }
    '/_player/wallet/withdraw': {
      id: '/_player/wallet/withdraw'
      path: '/withdraw'
      fullPath: '/wallet/withdraw'
      preLoaderRoute: typeof PlayerWalletWithdrawRouteImport
      parentRoute: typeof PlayerWalletRoute
    }
    '/_player/games/originals/': {
      id: '/_player/games/originals/'
      path: '/games/originals'
      fullPath: '/games/originals/'
      preLoaderRoute: typeof PlayerGamesOriginalsIndexRouteImport
      parentRoute: typeof PlayerRoute
    }
    '/_player/games/originals/$code': {
      id: '/_player/games/originals/$code'
      path: '/games/originals/$code'
      fullPath: '/games/originals/$code'
      preLoaderRoute: typeof PlayerGamesOriginalsCodeRouteImport
      parentRoute: typeof PlayerRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotRoute: typeof AuthForgotRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotRoute: AuthForgotRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PlayerWalletRouteChildren {
  PlayerWalletDepositRoute: typeof PlayerWalletDepositRoute
  PlayerWalletWithdrawRoute: typeof PlayerWalletWithdrawRoute
  PlayerWalletIndexRoute: typeof PlayerWalletIndexRoute
}

const PlayerWalletRouteChildren: PlayerWalletRouteChildren = {
  PlayerWalletDepositRoute: PlayerWalletDepositRoute,
  PlayerWalletWithdrawRoute: PlayerWalletWithdrawRoute,
  PlayerWalletIndexRoute: PlayerWalletIndexRoute,
}

const PlayerWalletRouteWithChildren = PlayerWalletRoute._addFileChildren(
  PlayerWalletRouteChildren,
)

interface PlayerRouteChildren {
  PlayerHistoryRoute: typeof PlayerHistoryRoute
  PlayerKycRoute: typeof PlayerKycRoute
  PlayerProfileRoute: typeof PlayerProfileRoute
  PlayerRedeemRoute: typeof PlayerRedeemRoute
  PlayerReferralRoute: typeof PlayerReferralRoute
  PlayerSettingsRoute: typeof PlayerSettingsRoute
  PlayerSpinRoute: typeof PlayerSpinRoute
  PlayerSportsRoute: typeof PlayerSportsRoute
  PlayerSupportRoute: typeof PlayerSupportRoute
  PlayerWalletRoute: typeof PlayerWalletRouteWithChildren
  PlayerIndexRoute: typeof PlayerIndexRoute
  PlayerCasinoCodeRoute: typeof PlayerCasinoCodeRoute
  PlayerLotteryCodeRoute: typeof PlayerLotteryCodeRoute
  PlayerLotteryResultsRoute: typeof PlayerLotteryResultsRoute
  PlayerLotteryTicketsRoute: typeof PlayerLotteryTicketsRoute
  PlayerPromosHistoryRoute: typeof PlayerPromosHistoryRoute
  PlayerCasinoIndexRoute: typeof PlayerCasinoIndexRoute
  PlayerLotteryIndexRoute: typeof PlayerLotteryIndexRoute
  PlayerPromosIndexRoute: typeof PlayerPromosIndexRoute
  PlayerGamesOriginalsCodeRoute: typeof PlayerGamesOriginalsCodeRoute
  PlayerGamesOriginalsIndexRoute: typeof PlayerGamesOriginalsIndexRoute
}

const PlayerRouteChildren: PlayerRouteChildren = {
  PlayerHistoryRoute: PlayerHistoryRoute,
  PlayerKycRoute: PlayerKycRoute,
  PlayerProfileRoute: PlayerProfileRoute,
  PlayerRedeemRoute: PlayerRedeemRoute,
  PlayerReferralRoute: PlayerReferralRoute,
  PlayerSettingsRoute: PlayerSettingsRoute,
  PlayerSpinRoute: PlayerSpinRoute,
  PlayerSportsRoute: PlayerSportsRoute,
  PlayerSupportRoute: PlayerSupportRoute,
  PlayerWalletRoute: PlayerWalletRouteWithChildren,
  PlayerIndexRoute: PlayerIndexRoute,
  PlayerCasinoCodeRoute: PlayerCasinoCodeRoute,
  PlayerLotteryCodeRoute: PlayerLotteryCodeRoute,
  PlayerLotteryResultsRoute: PlayerLotteryResultsRoute,
  PlayerLotteryTicketsRoute: PlayerLotteryTicketsRoute,
  PlayerPromosHistoryRoute: PlayerPromosHistoryRoute,
  PlayerCasinoIndexRoute: PlayerCasinoIndexRoute,
  PlayerLotteryIndexRoute: PlayerLotteryIndexRoute,
  PlayerPromosIndexRoute: PlayerPromosIndexRoute,
  PlayerGamesOriginalsCodeRoute: PlayerGamesOriginalsCodeRoute,
  PlayerGamesOriginalsIndexRoute: PlayerGamesOriginalsIndexRoute,
}

const PlayerRouteWithChildren =
  PlayerRoute._addFileChildren(PlayerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  PlayerRoute: PlayerRouteWithChildren,
  LoginImpersonateRoute: LoginImpersonateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
